/** 接口调用工具 */
import axios from 'axios'; // 引用axios
import jumuc from './api.js';
import {
    Toast
} from 'vant';
// eslint-disable-next-line no-unused-vars

// 配置API接口地址
var root = ''; // 测试true
var egg = '';
// TODO 需要更改
var andoridVersion = '4.0';
var iosVersion = '4.0';
var iosUpdateUrl = 'itms://itunes.apple.com/cn/app/id1476753099';
var androidUpdateUrl = 'http://wx.jumuc.com/appUpdate/appupdate.xml';
var androidApkUpdateUrl = 'https://www.jumuc.com/jumuc.apk';
var goodsClassId = {};
if (process.env.NODE_ENV === 'development') { // 本地服务器
    // egg='http://192.168.2.5:8080/egg/egg/index.html';
    // root='http://wx.jumuc.com/'
    // root='http://192.168.2.6:8090/'
    // root='http://192.168.2.102:8090/'
    // root='http://10.6.51.199:8090/'
    // root = 'http://dev.jumuc.com/';
    root = 'http://10.6.51.215:8080/';
    androidUpdateUrl = 'http://wx.jumuc.com/appUpdate/appupdate.xml';
    androidApkUpdateUrl = 'http://10.6.51.217/jumuc/jumuc.apk';
    // root='http://edus.shili.pro/'
} else if (process.env.VUE_APP_CURRENTMODE === 'test') { // 测试服务器
    // root = 'http://dev.jumuc.com/';
    root = 'http://10.6.51.215:8080/';
    androidUpdateUrl = 'http://10.6.51.212/h5/appUpdate/appupdate.xml';
    androidApkUpdateUrl = 'http://10.6.51.212/jumuc/jumuc.apk';
} else if (process.env.VUE_APP_CURRENTMODE === 'prod') { // 生产服务器
    root = 'http://app.jumuc.com/';
}

egg = 'http://wx.jumuc.com/egg/index.html';
goodsClassId['finishedFeed'] = 66188; // 成品饲料
goodsClassId['feedsTuff'] = 66228; // 饲料原料
goodsClassId['fhyp'] = 66390;
goodsClassId['veterinaryDrugs'] = 66093; // 兽药
goodsClassId['ranchSupplies'] = 66065; // 牧场用品
goodsClassId['frozenSemen'] = 66084; // 冻精
goodsClassId['explosionPromotion'] = 66275; // 爆款促销
goodsClassId['testingupplies'] = 66018; // 检测用品
axios.interceptors.request.use(
    config => {
        if (config.url.indexOf('/workFlow/userImgUpload.htm') != -1 ||
            config.url.indexOf('/payfileUpload.htm') != -1 || config.url.indexOf('/upload.htm') != -1) {
            config.headers['Content-Type'] = 'multipart/form-data';
        } else {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        }
        const toast = Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: ''
        });
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 自定义判断元素类型JS
function toType(obj) {
    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}

/** 参数过滤函数 */
function filterNull(o) {
    for (var key in o) {
        if (o[key] === null) {
            delete o[key];
        }
        if (toType(o[key]) === 'string') {
            o[key] = o[key].trim();
        } else if (toType(o[key]) === 'object') {
            o[key] = filterNull(o[key]);
        } else if (toType(o[key]) === 'array') {
            o[key] = filterNull(o[key]);
        }
    }
    return o;
}

/** 添加headers,可以动态添加header参数 */
function setHeaders(url) {
    if (url.indexOf('api/user/') != -1 || url.indexOf('api/wrokflow/') != -1 || url.indexOf('jmGoods') != -1 || url.indexOf('pay/') != -1) {
        axios.defaults.headers.Authorization = localStorage.getItem('token');
    } else {
        // 登录后，就传token,解决首页登录后，接口传的token不对
        if (localStorage.getItem('token') && localStorage.getItem('token') != '') {
            axios.defaults.headers.Authorization = localStorage.getItem('token');
        } else {
            axios.defaults.headers.Authorization = 123456;
        }
    }
    // axios.defaults.headers.Authorization = localStorage.getItem("token");
}

// 其实success与failure这两个参数，传过来的是两个放方法
function apiAxios(method, url, params, success) {
    setHeaders(url);
    if (params) {
        params = filterNull(params);
    }
    axios({
            method: method,
            url: url,
            data: method === 'POST' || method === 'PUT' ? params : null,
            params: method === 'GET' || method === 'DELETE' ? params : null,
            baseURL: root,
            withCredentials: false
        })
        .then(function (res) {
            Toast.clear();
            if (res.headers.authorization) {
                localStorage.setItem('token', res.headers.authorization); // token
            }
            success(res.data);
        }).catch(function (err) {
            Toast.clear();
            let res = err.response;
            if (res) {
                success(res.data);
            }
        });
}

// 返回在vue模板中的调用接口
export default {
    root: root,
    egg: egg,
    andoridVersion: andoridVersion,
    iosVersion: iosVersion,
    iosUpdateUrl: iosUpdateUrl,
    androidUpdateUrl: androidUpdateUrl,
    androidApkUpdateUrl: androidApkUpdateUrl,
    goodsClassId: goodsClassId,
    get: function (url, params, success) {
        return apiAxios('GET', url, params, success);
    },
    post: function (url, params, success) {
        return apiAxios('POST', url, params, success);
    },
    put: function (url, params, success) {
        return apiAxios('PUT', url, params, success);
    },
    delete: function (url, params, success) {
        return apiAxios('DELETE', url, params, success);
    },
    upload: function (url, forms, success) {
        return axios.post(url, forms, {}).then(res => {
            Toast.clear();
            success(res);
        });
    },
    isLogin() { // 判断是否登录
        return localStorage.getItem('token') != null;
    },
    toLogin() { // 判断是否登录并跳转登录页
        if (this.isLogin()) {
            // location.href = "#/login";
            location.href = '#/usercent';
        } else {
            location.href = '#/login';
        }
    },
    addCart(goodsId, count, spec, skuCode, enablePackType, selectPayMentType, success) { // 加入购物车
        if (this.isLogin()) {
            return this.post(jumuc.cart.add, {
                goodsId: goodsId,
                count: count,
                spec: spec,
                skuCode: skuCode,
                enablePackType: enablePackType,
                selectPayMentType: selectPayMentType
            }, success);
        } else {
            Toast({
                message: '请先登录',
                duration: 3000,
                onClose: function () {
                    location.href = '#/login';
                }
            });
        }
    },
    areaList(parent_id) { // 获取省市区公共接口
        return this.post(jumuc.userCenter.areaList, {
            parent_id: parent_id
        }, success);
    },
    paymentCodes(success) { // 支付渠道
        return this.get(jumuc.pay.onLinePaymentCodes, {}, success);
    },
    formatTime(date, fmt) {
        if (date == null) {
            return '';
        }
        var date = new Date(date.replace(/-/g, '/'));
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        var o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds()
        };
        for (var k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                var str = o[k] + '';
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
            }
        }
        return fmt;
    }
};